module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_10-50cf77ac766b8975469098f3f985371a.jpg";